// @flow
import React from "react";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import * as Icon from "../Icons/Tournaments";
import Money from "../Money";
import HowMuchInBucks from "../HowMuchInBucks";
import { fontSize } from "../common/styled-mixins";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  display: inline;
  font-size: ${fontSize(12)};
  color: #99959d;
`;

const TimeContainer = styled.div`
  margin-top: 5px;
  font-size: ${({ theme }) => (theme.locale === "ar" ? "15px" : "14px")};
  color: #99959d;
`;

const IconContainer = styled.div`
  width: 28px;
  height: 35px;
  margin-right: ${({ theme }) => (theme.direction === "rtl" ? "0" : "4px")};
  margin-left: ${({ theme }) => (theme.direction === "rtl" ? "4px" : "0")};
  color: ${({ theme, isTradePage }) =>
    isTradePage ? "#ffffff" : theme.foreground};
`;

const Value = styled(Money.Value)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme, istradepage }) =>
    istradepage ? "#ffffff" : theme.foreground};
`;

const Currency = styled(Money.Symbol)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme, istradepage }) =>
    istradepage ? "#feac00" : theme.accent};
`;

type Props = {
  prize_fund: number,
  prize_fund_usd: number
};

export default function PrizeFund({
  prize_fund,
  prize_fund_usd,
  isTradePage
}: Props) {
  return (
    <Container>
      <IconContainer isTradePage={isTradePage}>
        <Icon.Cup width={28} height={35} />
      </IconContainer>
      <div>
        <Text>
          <Gettext>Prize fund</Gettext>:
        </Text>
        <TimeContainer>
          <HowMuchInBucks
            value={prize_fund}
            valueUSD={prize_fund_usd}
            valueStyle={Value}
            symbolStyle={Currency}
            divider="&nbsp;/&nbsp;"
            isTradePage={isTradePage}
          />
        </TimeContainer>
      </div>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/PrizeFund.js